export default {"src":"/_next/static/media/ar_down.93d782a2.svg","height":9,"width":14,"blurWidth":0,"blurHeight":0};